module.exports = __webpack_public_path__ + "img/no_image.0a47bfde.jpg";